var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row bg-white shadow py-5 px-3 mb-4" }, [
      _c("div", { staticClass: "col-11" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-2 text-center" }, [
            _c("b", [_vm._v("#")])
          ]),
          _c("div", { staticClass: "col-2" }, [_c("b", [_vm._v("Estado")])]),
          _c("div", { staticClass: "col-8" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-4" }, [
                _c("b", [_vm._v("Aduana Loteadora")])
              ]),
              _c("div", { staticClass: "col-2" }, [
                _c("b", [_vm._v("Requiere VB")])
              ]),
              _c("div", { staticClass: "col-2" }, [
                _c("b", [_vm._v("Ex Lote")])
              ]),
              _c("div", { staticClass: "col-3" }, [
                _c("b", [_vm._v("Calidad jurídica")])
              ])
            ])
          ])
        ])
      ]),
      _c("div", { staticClass: "col-1 text-center" }, [
        _c("b", [_vm._v("...")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }